import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import Header from "@/components/navigation/Header";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted">
      <Header />
      <main className="flex min-h-[calc(100vh-80px)] items-center justify-center px-4 py-8">
        <div className="text-center max-w-4xl mx-auto">
          <div className="mb-8">
            <img 
              src="/assets/404-astronaut-bitcoin.jpg" 
              alt="Astronaut holding Bitcoin on the moon"
              className="mx-auto max-w-md w-full h-auto rounded-lg shadow-bitcoin"
            />
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold text-bitcoin-orange mb-4">
            Houston We Have a Problem!
          </h1>
          
          <div className="text-6xl md:text-8xl font-bold text-primary mb-6">
            404
          </div>
          
          <p className="text-xl md:text-2xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            Looks like this page got lost in space. Don't worry, our Bitcoin astronaut 
            is on a mission to help you find your way back to Earth.
          </p>
          
          <Button 
            variant="bitcoin" 
            size="lg"
            onClick={() => window.location.href = "/"}
            className="text-lg px-8 py-4"
          >
            Return to Mission Control
          </Button>
        </div>
      </main>
    </div>
  );
};

export default NotFound;
